import {message, Spin, Divider, Modal} from "antd";
import styled from "styled-components";
import {CoAdministrator} from "./components/CoAdministrator";
import {Administrator} from "./components/Administrator";
import {useMutation, useQuery} from "react-query";
import {
    addAdministrator,
    delAdministrator,
    getAdministratorList,
    reInviteAdmin,
} from "../../../api/User";
import {useMemo, useState} from "react";
import {AddAdministrator} from "./components/AddAdministrator";

const Container = styled.div`
  padding: 20px;
  .ant-space {
    display: flex;
  }
`

export const MfAdministrator = () => {
    const {data, isFetching: isLoading, refetch} = useQuery('adminList', getAdministratorList)
    const {mutateAsync: addAdminMutate, isLoading: addLoading,} = useMutation(addAdministrator)
    const {mutateAsync: delAdminMutate} = useMutation(delAdministrator)
    const {mutateAsync: reInviteAdminMutate} = useMutation(reInviteAdmin)
    const [inviteModal, setInviteModal] = useState(false)

    const admin = useMemo(() => {
        return data?.data.company_admin || {}
    }, [data])

    const list = useMemo(() => {
        return data?.data.company_co_admins || []
    }, [data])

    const limit = useMemo(() => {
        return data?.data.left_limit ?? 5
    }, [data])

    const onSubmit = (values) => {
        Modal.confirm({
            title: 'Invite',
            content: `Are you sure you want to invite "${values.username}"?`,
            okText: 'Invite',
            okButtonProps: {style: {minWidth: 90}},
            cancelButtonProps: {style: {width: 90}},
            onOk: async () => {
                const res = await addAdminMutate(values)
                if (+res?.code === 10000) {
                    setInviteModal(false)
                    message.success('Invite successfully');
                    await refetch()
                }
            }
        })
    }

    const delAdmin = (user) => {
        Modal.confirm({
            title: 'Remove Co-Administrator',
            content: `Are you sure you want to remove ${user?.user.name}?`,
            okText: 'Confirm',
            okButtonProps: {style: {minWidth: 90}},
            cancelButtonProps: {style: {width: 90}},
            onOk: async () => {
                const res = await delAdminMutate(user.user_id)
                if (+res?.code === 10000) {
                    message.success('Delete successfully');
                    await refetch()
                }
            }
        })
    }

    const reInvite = (user) => {
        Modal.confirm({
            title: 'Reinvite',
            content: `Are you sure you want to reinvite "${user.user.name}"?`,
            okText: 'Reinvite',
            okButtonProps: {style: {minWidth: 90}},
            cancelButtonProps: {style: {width: 90}},
            onOk: async () => {
                const res = await reInviteAdminMutate(user.user_id)
                if (+res?.code === 10000) {
                    setInviteModal(false)
                    message.success('Invite successfully');
                    await refetch()
                }
            }
        })
    }

    return (
        <Spin spinning={isLoading}>
            <Container>
                <Administrator data={admin} />
                <Divider />
                <CoAdministrator
                    list={list}
                    limit={limit}
                    del={delAdmin}
                    reInvite={reInvite}
                    add={() => setInviteModal(true)} />
                <AddAdministrator
                    visible={inviteModal}
                    cancel={() => setInviteModal(false)}
                    loading={addLoading}
                    submit={onSubmit} />
            </Container>
        </Spin>
    )
}